import { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { Route, Routes, useLocation } from "react-router-dom";
import AppTopbar from "./layouts/AppTopbar";
import AppMenu from "./layouts/AppMenu";
import Dashboard from "./pages/dashboard/Dashboard";
import { Tooltip } from "primereact/tooltip";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.scss";
import ChangePassword from "./pages/Profile/ChangePassword";
import Services from "./pages/Master/Services/Services";
import BookingSlots from "./pages/Master/BookingSlots/BookingSlots";
import Crops from "./pages/Master/Crops/Crops";
import ServiceItem from "./pages/Master/ServiceItem/ServiceItem";
import Farmer from "./pages/Farmer/FarmerList";
import FarmerDetail from "./pages/Farmer/FarmerDetail";
import OperatorList from "./pages/operators/operators/OperatorList";
import OperatorDetail from "./pages/operators/operators/OperatorDetail";
import BookingList from "./pages/bookings/BookingList";
import BookingDetail from "./pages/bookings/BookingDetail";
import AddEditService from "./pages/Master/Services/AddEditService";
import Equipments from "./pages/operators/equipments/Equipments";
import AddBooking from "./pages/bookings/AddBooking";
import GlobalData from "./pages/setting/GlobalData";
import SprayForProblemList from "./pages/Master/sprayForProblem/SprayForProblemList";
import AnnounceList from "./pages/announcements/AnnounceList";
import SoilTestParameter from "./pages/Master/SoilTestParameter/SoilTestParameter";
import FTCPartner from "./pages/FTCPartner/FTCPartner";
import OperatorReport from "./pages/reports/OperatorReport";

const App = (props: any) => {
  const [menuMode, setMenuMode] = useState("slim");
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [sidebarStatic, setSidebarStatic] = useState(false);
  const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] =
    useState(false);
  const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [topbarMenuActive, setTopbarMenuActive] = useState(false);
  const [sidebarActive, setSidebarActive] = useState(false);
  const [pinActive, setPinActive] = useState(false);
  const [activeInlineProfile, setActiveInlineProfile] = useState(false);
  const [resetActiveIndex, setResetActiveIndex] = useState<boolean>(false);
  const copyTooltipRef = useRef<any>();
  const location = useLocation();

  const updateTime = 60000;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setMenuMode("sidebar");
      } else {
        setMenuMode("slim");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Menu Items
  const menu = [
    {
      label: "Dashboard",
      icon: "pi pi-home",
      to: "/dashboard",
    },
    {
      label: "Master",
      icon: "pi pi-database",
      to: "/master",
      items: [
        { label: "Services", to: "/master/services" },
        // { label: "Booking Slots", to: "/master/booking-slots" },
        { label: "Crops", to: "/master/crops" },
        { label: "Service Item", to: "/master/service-item" },
        { label: "Spray For Problem", to: "/master/spray-for-problem" },
        { label: "Soil Test Parameter", to: "/master/soil-test-parameter" },
      ],
    },
    {
      label: "Farmers",
      icon: "pi pi-user",
      to: "/farmer",
    },
    {
      label: "Operators",
      icon: "fa fa-headset",
      to: "/operator",
      items: [
        { label: "Operators", to: "/operator/operator-list" },
        { label: "Equipments", to: "/operator/equipments" },
      ],
    },
    {
      label: "Bookings",
      icon: "pi pi-book",
      to: "/booking",
    },
    {
      label: "Report",
      icon: "pi pi-chart-bar",
      to: "/report",
      items: [
        { label: "Operator Report", to: "/report/operator-report" },
      ],
    },
    {
      label: "Announce",
      icon: "pi pi-bell",
      to: "/announcements",
    },
    {
      label: "Setting",
      icon: "pi pi-spin pi-cog",
      to: "/setting",
      items: [{ label: "Global Data", to: "/setting/global-data" }],
    },
    // {
    //   label: "FTC Partner",
    //   icon: "pi pi-users",
    //   to: "/ftc-partner",
    // },
  ];

  let menuClick: any;

  let topbarItemClick: any;

  useEffect(() => {
    copyTooltipRef &&
      copyTooltipRef.current &&
      copyTooltipRef.current.updateTargetEvents();
  }, [location]);

  useEffect(() => {
    unblockBodyScroll();
    setOverlayMenuActive(false);
    setStaticMenuMobileActive(false);
  }, [location]);

  useEffect(() => {
    setResetActiveIndex(true);
    setMenuActive(false);
  }, [menuMode]);

  const onDocumentClick = () => {
    if (!topbarItemClick) {
      setTopbarMenuActive(false);
    }

    if (!menuClick) {
      if (isHorizontal() || isSlim()) {
        setMenuActive(false);
        setResetActiveIndex(true);
      }

      if (overlayMenuActive || staticMenuMobileActive) {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
      }

      hideOverlayMenu();
      unblockBodyScroll();
    }

    topbarItemClick = false;
    menuClick = false;
  };

  const hideOverlayMenu = () => {
    setOverlayMenuActive(false);
    setStaticMenuMobileActive(false);
  };

  const onTopbarItemClick = (event: any) => {
    topbarItemClick = true;
    setTopbarMenuActive((prevState) => !prevState);
    hideOverlayMenu();
    event.preventDefault();
  };

  const onToggleMenu = (event: any) => {
    menuClick = true;

    if (overlayMenuActive) {
      setOverlayMenuActive(false);
    }

    if (sidebarActive) {
      setSidebarStatic((prevState) => !prevState);
    }

    event.preventDefault();
  };

  const onSidebarMouseOver = () => {
    if (menuMode === "sidebar" && !sidebarStatic) {
      setSidebarActive(isDesktop());
      setTimeout(() => {
        setPinActive(isDesktop());
      }, 200);
    }
  };

  const onSidebarMouseLeave = () => {
    if (menuMode === "sidebar" && !sidebarStatic) {
      setTimeout(() => {
        setSidebarActive(false);
        setPinActive(false);
      }, 250);
    }
  };

  const onMenuClick = () => {
    menuClick = true;
  };

  const onChangeActiveInlineMenu = (event: any) => {
    setActiveInlineProfile((prevState) => !prevState);
    event.preventDefault();
  };

  const onRootMenuItemClick = () => {
    setMenuActive((prevState) => !prevState);
  };

  const isOverlay = () => menuMode === "overlay";

  const blockBodyScroll = () => {
    document.body.classList.add("blocked-scroll");
  };

  const onMenuButtonClick = (event: any) => {
    menuClick = true;

    if (isOverlay()) {
      setOverlayMenuActive((prev) => {
        const newState = !prev;
        newState ? blockBodyScroll() : unblockBodyScroll();
        return newState;
      });
    }

    if (isDesktop()) {
      setStaticMenuDesktopInactive((prev) => !prev);
    } else {
      setStaticMenuMobileActive((prev) => {
        const newState = !prev;
        newState ? blockBodyScroll() : unblockBodyScroll();
        return newState;
      });
    }

    event.preventDefault();
  };

  const onMenuItemClick = (event: any) => {
    if (!event.item.items) {
      hideOverlayMenu();
      setResetActiveIndex(true);
    }

    if (!event.item.items && (isHorizontal() || isSlim())) {
      setMenuActive(false);
    }
  };

  const isHorizontal = () => {
    return menuMode === "horizontal";
  };

  const isSlim = () => {
    return menuMode === "slim";
  };

  const isDesktop = () => {
    return window.innerWidth > 991;
  };

  const unblockBodyScroll = () => {
    if (document.body.classList) {
      document.body.classList.remove("blocked-scroll");
    } else {
      document.body.className = document.body.className.replace(
        new RegExp(
          "(^|\\b)" + "blocked-scroll".split(" ").join("|") + "(\\b|$)",
          "gi"
        ),
        " "
      );
    }
  };

  const layoutClassName = classNames("layout-wrapper", {
    "layout-static": menuMode === "static",
    "layout-overlay": menuMode === "overlay",
    "layout-overlay-active": overlayMenuActive,
    "layout-slim": menuMode === "slim",
    "layout-horizontal": menuMode === "horizontal",
    "layout-active": menuActive,
    "layout-mobile-active": staticMenuMobileActive,
    "layout-sidebar": menuMode === "sidebar",
    "layout-sidebar-static": menuMode === "sidebar" && sidebarStatic,
    "layout-static-inactive":
      staticMenuDesktopInactive && menuMode === "static",
  });

  return (
    <div className={layoutClassName} onClick={onDocumentClick}>
      <Tooltip
        ref={copyTooltipRef}
        target=".block-action-copy"
        position="bottom"
        content="Copied to clipboard"
        event="focus"
      />

      <AppTopbar
        items={menu}
        menuMode={menuMode}
        updateTime={updateTime}
        onMenuButtonClick={onMenuButtonClick}
        topbarMenuActive={topbarMenuActive}
        activeInlineProfile={activeInlineProfile}
        onTopbarItemClick={onTopbarItemClick}
        onToggleMenu={onToggleMenu}
      />

      <AppMenu
        model={menu}
        onRootMenuItemClick={onRootMenuItemClick}
        onMenuItemClick={onMenuItemClick}
        onToggleMenu={onToggleMenu}
        onMenuClick={onMenuClick}
        menuMode={menuMode}
        menuActive={menuActive}
        sidebarActive={sidebarActive}
        sidebarStatic={sidebarStatic}
        pinActive={pinActive}
        onSidebarMouseLeave={onSidebarMouseLeave}
        onSidebarMouseOver={onSidebarMouseOver}
        activeInlineProfile={activeInlineProfile}
        onChangeActiveInlineMenu={onChangeActiveInlineMenu}
        resetActiveIndex={resetActiveIndex}
      />

      <div className="layout-main">
        <div className="layout-main-content">
          <Routes>
            {/* dashboard route */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* change password route */}
            <Route path="/change-password" element={<ChangePassword />} />

            {/* master service route */}
            <Route path="/master/services" element={<Services />} />
            <Route
              path="/master/services/add-service"
              element={<AddEditService />}
            />
            <Route
              path="/master/services/edit-service/:id"
              element={<AddEditService />}
            />
            <Route
              path="/master/spray-for-problem"
              element={<SprayForProblemList />}
            />

            <Route
              path="/master/soil-test-parameter"
              element={<SoilTestParameter />}
            />

            {/* master booking slot route */}
            {/* <Route path="/master/booking-slots" element={<BookingSlots />} /> */}

            {/* master crop route */}
            <Route path="/master/crops" element={<Crops />} />

            {/* master service item route */}
            <Route path="/master/service-item" element={<ServiceItem />} />

            {/* Farmers route */}
            <Route path="/farmer" element={<Farmer />} />
            <Route path="/farmer/detail/:id" element={<FarmerDetail />} />

            {/* operator route */}
            <Route path="/operator/operator-list" element={<OperatorList />} />
            <Route path="/operator/detail/:id" element={<OperatorDetail />} />

            {/* equipments route */}
            <Route path="/operator/equipments" element={<Equipments />} />

            {/* bookings route */}
            <Route path="/booking" element={<BookingList />} />
            <Route path="/booking/add-booking" element={<AddBooking />} />
            <Route path="/booking/detail/:id" element={<BookingDetail />} />

            {/* reports */}
            <Route path="/report/operator-report" element={<OperatorReport />} />

            {/* announceMents */}
            <Route path="/announcements" element={<AnnounceList />} />

            {/* setting route */}
            <Route path="/setting/global-data" element={<GlobalData />} />

             {/* FTC Partner route */}
            {/* <Route path="/ftc-partner" element={<FTCPartner />} /> */}
          </Routes>
        </div>

        {/* show mask when mobile active sidebar */}
        {(staticMenuMobileActive || overlayMenuActive) && (
          <div className="layout-mask" />
        )}
      </div>
    </div>
  );
};

export default App;
